import { useGetHatoTokenQuery, useGetUserDataQuery } from "../../redux/api/userApiSlice";
import { ChatWidget } from "../ChatWidget";
import { useParams } from "react-router-dom";
import { useGetNegotiationDetailQuery } from "../../redux/api/negotiationsApiSlice";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { canUseChat } from "../../utils/permission";

export const NegotiationChat = () => {

  const { id } = useParams();
  const { data: user } = useGetUserDataQuery();
  const { data: negotiation } = useGetNegotiationDetailQuery(id ?? skipToken);
  const { data: accessData } = useGetHatoTokenQuery(negotiation?.chat_room_uuid ? {} : skipToken);

  return (
    <>
      {
        negotiation &&
        negotiation?.chat_room_uuid !== null &&
        user &&
        accessData &&
        accessData.token &&
        accessData.refresh &&
        accessData.hato_url &&
        accessData.ws_url &&
        canUseChat(user.usertypes.map(u => u.code)) && (
        <ChatWidget
          authToken={accessData.token}
          refreshToken={accessData.refresh}
          canSendMessages={true}
          pinnedRoomId={negotiation.chat_room_uuid}
          apiBaseUrl={accessData.hato_url}
          websocketUrl={accessData.ws_url}
          buttonProps={{style: {right: 100}}}
        />)}
    </>
  );
};